(function () {
  "use strict";

  angular
    .module("admin.users.details.roles.service", [])
    .factory("UserRolesService", UserRolesService);

  /** @ngInject */
  function UserRolesService($http, $q, API) {
    function list(id, start, limit) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/users/" +
            id +
            "/user_roles?start=" +
            start +
            "&limit=" +
            limit
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function get(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/user_roles/" + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function save(model) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/user_roles", model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function update(id, model) {
      var defered = $q.defer();

      $http
        .put(API.API_URL + "admin/user_roles/" + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function remove(id) {
      var defered = $q.defer();

      $http
        .delete(API.API_URL + "admin/user_roles/" + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return {
      list: list,
      get: get,
      save: save,
      update: update,
      remove: remove,
    };
  }
})();
